import {Component, AfterViewInit, OnInit, Inject} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Article } from '../../shared/models/kb-articles.model';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormGroup } from '@angular/forms';
import * as UIC from '@dds-uicore/all';
import { DatePipe } from '@angular/common'
import { NavService } from 'src/app/shared/services/nav.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GlobalConstants } from 'src/app/shared/global-constants';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as moment from 'moment';
export interface StatusDialogData {
  comment:string;
  status:string;
  folder: string;
  duplictatefileNameMessage: any;
  startDateError:string;
}
@Component({
  selector: 'app-kb-articles-display',
  templateUrl: './kb-articles-display.component.html',
  styleUrls: ['./kb-articles-display.component.scss']
})
export class KbArtilesSingleComponent implements OnInit,AfterViewInit {
  editUrl: string;
  username:string="Jon Snow"
  editMode:boolean=false;
  newComment=[];
  more:boolean=false;
  addForm: UntypedFormGroup;
  editForm: UntypedFormGroup;
  currentUrl:string;
  currentArticleID:string;
  loading:boolean=false;
  attachmentLoading:boolean=false;
  article:Article;
  id: any;
  commentDate: Date;
  commentFormVisible: boolean = false;
  editCommentID: string='';
  modal: any;
  Content="";
  secondaryStatus:string="";
  RoleName: string;
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;
  dloUser = GlobalConstants.dloUser;
  Drafted = GlobalConstants.Drafted;
  Published = GlobalConstants.Published;
  PendingApproval = GlobalConstants.PendingApproval;
  Deleted = GlobalConstants.Deleted;
  Rejected = GlobalConstants.Rejected;
  Scheduled = GlobalConstants.Scheduled;
  Expired = GlobalConstants.Expired;
  Public = GlobalConstants.Public;
  Restricted = GlobalConstants.Restricted;
  articleAlreadyTakenErrorMessage: string = "Article Name Already taken. Please rename the existing one to proceed."
  isFolderNameTaken: boolean = false;
  result: any;
  folderName: any;
  statusMap = new Map<string, string>([
    [this.Drafted,"dds__label-badge-solid-granite"],
    [this.PendingApproval,"dds__label-badge-solid-status-yellow"],
    [this.Published,"dds__label-badge-solid-status-green"],
    [this.Rejected,"dds__label-badge-solid-berry"],
    [this.Deleted,"dds__label-badge-solid-status-red"],
    [this.Scheduled,"dds__label-badge-solid-status-yellow"],
    [this.Expired,"dds__label-badge-solid-status-red"]
  ]);

  accesslevelMap = new Map<string, string>([
    [this.Public,"dds__label-badge-solid-sea-blue"],
    [this.Restricted,"dds__label-badge-solid-status-orange"],
  ]);
  AttachmentURL: any;
  endDateError: string;
  startDateError: string;
  articleStatus: any;
  constructor(private datePipe: DatePipe,private router:Router,public dialog: MatDialog, private route: ActivatedRoute,private authService:AuthService,private navService:NavService,private commonService:CommonService,private _snackBar: MatSnackBar,) {}
  openDialog(statusRec): void {
    this.folderName = this.router.url.split('/')[2];
    const dialogRef = this.dialog.open(StatusPopup, {
      data: {comment: '',status:statusRec, folder: this.folderName, startDateError: this.startDateError}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.click)
          this.updateArticleStatus(statusRec,result.comment)
    });
  }
  DefaultStartDate(startDate):any{
    let defaultStartDate,today;
    defaultStartDate= this.datePipe.transform(startDate, 'MM/dd/yyyy');
    if(this.articleStatus==this.PendingApproval){ //Defaulting of dates is meant only for Pending Approval Articles
        today = moment().format("MM/DD/YYYY").toString();
    if(moment(defaultStartDate).isBefore(today)){ //If startDate is less than today, then it is defaulted otherwise left
        this.startDateError="Please note: StartDate has been updated to current date as it cannot be less than the current date!";
        defaultStartDate=today;
      }
    }
    return defaultStartDate;
  }
  checkEndDates(enddate){
    if(enddate){
      let today = moment().format("MM/DD/YYYY").toString();
      if(moment(enddate).isBefore(today))
          this.endDateError="End Date cannot be less than the current date! Please edit the article to resolve the error. ";
      else if (moment(enddate).isBefore(this.article.ScheduledStartDate))
          this.endDateError="Start Date cannot be greater than End Date!! Please edit the article to resolve the error. ";
      else
          this.endDateError=null;
    }
  }
  openDialogForRestore(statusRec,errorMessage): void {
    if(errorMessage == undefined || errorMessage == "")
     this.folderName = this.router.url.split('/')[2];
     else
     this.folderName = this.folderName;
     const dialogRef = this.dialog.open(StatusPopup, {
       data: { comment: '', status: statusRec, folder: this.folderName.split('_').join(' '),duplictatefileNameMessage:errorMessage}
     });
     dialogRef.afterClosed().subscribe(result => {
       if (result && result.click && statusRec == "Deleted") {
         this.folderName = result.folder;
         if (this.navService.checkValidity(result.folder))
           this.checkArticleNameExists(result.folder);
       }
     });
   }

   //Restoring
   checkArticleNameExists(folderName) {
    let folderId = this.navService.findFolderID(this.route.snapshot.url);
    // let folderName =folderName;
    this.commonService.checkFolderNameExists(folderId, folderName).subscribe(
      data => {
        this.result = data;
        if (this.result.Status == "Success") {
          //call the Rename Folder API
          this.commonService.updateNavItemForRestoring(folderId, folderName);
          this.commonService.getNavList();
          this.editUrl=this.editUrl.replace(this.editUrl.split('/')[2],folderName.toLowerCase().split(' ').join('_'));
          this.router.navigate([this.editUrl, this.article.Id]);
          return true;
        }
        else {
          this.openDialogForRestore(this.Deleted,"* File Name already taken.");
          return false;
        }
      }
    )


  }


  updateArticleStatus(status,Comments){
    let folderId=this.navService.findFolderID(this.route.snapshot.url)
    this.commonService.updateArticles(this.article.Id,this.article.Title, this.article.Content, null,null,0, this.router.url.substring(1), status,this.article.Accesslevel,this.article.ScheduledStartDate,this.article.ScheduledEndDate,folderId,Comments,true);
  }

  toggleDisplay(){
    this.commentFormVisible=true;
  }

  custom(){
   this.modal.show()

  }

  createAttachmentURL(data){
    this.article.AttachmentUrl=data.AttachmentUrl;
    this.AttachmentURL=data.AttachmentUrl;
    this.attachmentLoading=false;
  }
  renderAttachment(){
    if(!this.article.AttachmentId) //Show All will not render Attachments if not present
        return;
    if(!this.article.AttachmentUrl){
      this.attachmentLoading=true;
      this.AttachmentURL="";
      let attachmentId:number;
      if(this.commonService.localArticle && this.commonService.localArticle[this.currentArticleID].AttachmentUrl){
        let data=this.commonService.localArticle[this.currentArticleID];
             attachmentId =data.AttachmentId[0];
             this.article.AttachmentUrl=data.AttachmentUrl;
             this.AttachmentURL=data.AttachmentUrl;
             this.attachmentLoading=false;       
      }
      else{
        attachmentId = this.article.AttachmentId[0];
        this.fetchAttachmentStreamData(attachmentId);
      }
      
    }
  }
  fetchAttachmentStreamData(attachmentId:number){
    this.commonService.fetchAttachmentStream(attachmentId).subscribe(result=>{
      if(result.size!=0){  
        var blob = new Blob([result], { type: result.type });
        var url = window.URL.createObjectURL(blob);
        this.commonService.localArticle[this.currentArticleID].AttachmentUrl=url;
        console.log(this.commonService.localArticle[this.currentArticleID]);
        this.article.AttachmentUrl=url;
        this.AttachmentURL=url;
        this.attachmentLoading=false;
      }
      else{
        this.commonService.setNotification("Something went wrong! Please try again in some time.","Error");
        this.router.navigateByUrl('/home');
        return;
    }
      
    });
  }
 
  setArticle(data){
    console.log(data);   
    this.articleStatus=data.Status;
    this.article={
      Id:this.currentArticleID,
      Title:data.Title,
      Content:data.Content,
      AttachmentId:data.AttachmentId,
      Status:data.Status,
      Accesslevel:data.Accesslevel,
      PublisherName:data.PublisherName,
      ScheduledStartDate:this.DefaultStartDate(data.ScheduledStartDate),
      ScheduledEndDate:data.ScheduledEndDate,
      Comments:data.Comments
    }
    this.checkEndDates(this.article.ScheduledEndDate);
    this.secondaryStatus="";//IMPORTANT TO INITIALIZE IT AT EVERY PAGE
          if(this.article.Status===this.Published){
            let startdt=moment(this.article.ScheduledStartDate).format("YYYY-MM-DD");
            let enddt= this.article.ScheduledEndDate && moment(this.article.ScheduledEndDate).format("YYYY-MM-DD");
            let today = moment(new Date).format("YYYY-MM-DD");
            if(startdt > today)
              this.secondaryStatus=this.Scheduled;
            else if(this.article.ScheduledEndDate && enddt < today)
              this.secondaryStatus=this.Expired;
          }
          this.loading=false;
  }
  ngAfterViewInit(){
    //dds form
  [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__form-validation\"]"), function (element) {
    new UIC.Form(element, { validate: "true" });
  });

  //tooltip
  [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__tooltip\"]"), function(element) { new UIC.Tooltip(element); });

  }
  ngOnInit(): void {
    this.secondaryStatus="";//IMPORTANT TO INITIALIZE IT AT EVERY PAGE
    this.authService.itemValue.subscribe((nextValue) => {
      this.RoleName=nextValue.RoleName;

    });
  //tab navs
  [].forEach.call(document.querySelectorAll('[data-toggle="dds__tab"]'), function(element) {
    new UIC.Tab(element);
  });
  //pagination
    [].forEach.call(document.querySelectorAll("[data-toggle='dds__pagination']"), function(element) {
        new UIC.Pagination(element);
    });
  //dds accordian
  [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__collapse\"]"), function(element) {
        new UIC.Collapse(element);
      });

      this.route.params.subscribe(params => {     
      this.id = params.id;
      this.currentUrl= this.router.url;
      this.editUrl=this.currentUrl.substring(0,this.currentUrl.lastIndexOf('/'))+'/edit';
      this.currentArticleID = this.currentUrl.substring(this.currentUrl.lastIndexOf('/')+1);
      this.loading=true;
      if(this.commonService.localArticle && this.commonService.localArticle[this.currentArticleID]){
        let data=this.commonService.localArticle[this.currentArticleID];
        this.setArticle(data);
      }
      else{
      this.commonService.fetchOneArticle(this.currentArticleID).subscribe(
        articleData =>{
          if(articleData.Status=="Failure"){
            this.commonService.setNotification("Something went wrong! Please try again in some time.","Error");
            this.router.navigateByUrl('/home');
          }
          else if(articleData.Error=="Unauthorized"){
            this.commonService.setNotification("Access Restricted!","Error");
            this.router.navigateByUrl('/home');
          }
          let data = articleData.data;
          this.setArticle(data);
          this.commonService.localArticle[this.currentArticleID]=this.article;

        })
      }
      document.getElementById('panelTwo').className='dds__collapse';
      document.getElementById('panelTwoButton').className='dds__accordion-btn dds__collapsed dds__d-flex';
      document.getElementById('panelOneNested').className='dds__collapse dds__show';
      document.getElementById('panelOneNestedButton').className='dds__accordion-btn dds__d-flex';
    })

  }
  btnBack(articleStatus){
    console.log('hi',articleStatus,localStorage.getItem("route"))
    if(localStorage.getItem("route")=='portal'){
      this.router.navigateByUrl('/portal');
    }
    else{
      if(localStorage.getItem("route")=='grid'){
      this.router.navigateByUrl('/grid/'+articleStatus);
      }
      else{
        this.router.navigateByUrl('/');
      }
    }
  }
}

@Component({
  selector: 'status-popup',
  templateUrl: 'popup-kb-articles.html',
  styleUrls: ['./kb-articles-display.component.scss'],
})
export class StatusPopup {
  Drafted = GlobalConstants.Drafted;
  Published = GlobalConstants.Published;
  PendingApproval = GlobalConstants.PendingApproval;
  Deleted = GlobalConstants.Deleted;
  Rejected = GlobalConstants.Rejected;
  constructor(
    public dialogRef: MatDialogRef<StatusPopup>,private router:Router,
    @Inject(MAT_DIALOG_DATA) public data: StatusDialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
    }
  }  
